import React, { Component } from "react";
import PropTypes from "prop-types";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import S3Upload from "react-s3-uploader/s3upload";
import "../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

class TextEditor extends Component {
  constructor(props) {
    super(props);

    let editorState = EditorState.createEmpty();
    if (props.initialValue) {
      const contentBlock = htmlToDraft(props.initialValue);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks
        );
        editorState = EditorState.createWithContent(contentState);
      }
    }

    this.state = {
      editorState
    };
    // this.onChange = editorState => this.setState({ editorState });
  }

  handleChange = editorState => {
    this.setState({ editorState });
    this.props.onChange({
      target: {
        name: this.props.name,
        value: draftToHtml(convertToRaw(editorState.getCurrentContent()))
      }
    });
  };

  handleImageUpload = file => {
    const s3Url = `https://${process.env.REACT_APP_IMAGE_BUCKET}.s3.amazonaws.com`;
    const server = process.env.REACT_APP_SITE_API;
    const signingUrl = "/images/upload";

    return new Promise((resolve, reject) => {
      const handleError = err => {
        console.log(err); // eslint-disable-line
        reject(err);
      };

      const handleFinish = info => {
        const fileUrl = `${s3Url}/${info.filename}`;
        resolve({ data: { link: fileUrl } });
      };

      const uploadOptions = {
        files: [file],
        server,
        signingUrl,
        uploadRequestHeaders: { "x-amz-acl": "public-read" },
        onFinishS3Put: handleFinish,
        onError: handleError
        //   signingUrlWithCredentials: true
      };

      new S3Upload(uploadOptions); // eslint-disable-line
    });
  };

  render() {
    return (
      <Editor
        editorState={this.state.editorState}
        onEditorStateChange={this.handleChange}
        wrapperClassName="rounded border"
        toolbarClassName="bg-light"
        editorClassName="m-2"
        toolbar={{
          options: [
            "blockType",
            "list",
            "textAlign",
            "inline",
            "link",
            "image",
            "history"
          ],

          inline: { inDropdown: true },
          list: { inDropdown: true },
          textAlign: { inDropdown: true },
          link: { inDropdown: true },

          image: {
            uploadEnabled: true,
            previewImage: true,
            uploadCallback: this.handleImageUpload,
            alt: { present: false, mandatory: false }
          }
        }}
      />
    );
  }
}

TextEditor.propTypes = {
  initialValue: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

TextEditor.defaultProps = {
  initialValue: ""
};

export default TextEditor;
